import {
  Instacart_Care_Tools_V1_AccountType,
  Instacart_Care_Tools_V1_ServiceUser,
  useFindUsersQuery,
} from '../../api'

export const useFindUsers = (query: string) => {
  const { data, loading, error } = useFindUsersQuery({
    variables: {
      query,
      serviceUser: Instacart_Care_Tools_V1_ServiceUser.ServiceUserIppCxAdmin,
      adminAuditContext: {
        accountType: Instacart_Care_Tools_V1_AccountType.AccountTypeIpp,
      },
      limit: 20,
    },
    skip: query.trim().length === 0,
    fetchPolicy: 'cache-and-network',
  })

  const users = (data?.instacart_care_tools_v1_CareToolsService_FindUsers?.users ?? []).filter(
    Boolean
  )

  if (error) {
    return { data: null, loading, error: 'Failed to search users' }
  }

  return { data: users, loading, error: null }
}
